import { render, staticRenderFns } from "./code-list.vue?vue&type=template&id=5d832c0a&scoped=true"
import script from "./code-list.vue?vue&type=script&lang=js"
export * from "./code-list.vue?vue&type=script&lang=js"
import style0 from "./code-list.vue?vue&type=style&index=0&id=5d832c0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d832c0a",
  null
  
)

export default component.exports